import * as React from 'react';

import classnames from 'classnames';

import {ListRowWithIcon} from '../list-row/list-row-with-icon';

import styles from './two-line-option-card.module.css';

type Props = {
    onClick?: () => any;
    title: string | React.ReactNode;
    subtitle: string | React.ReactNode;
    icon: React.ComponentType<any> | React.ReactNode;
    isSelected?: boolean;
    isDisabled?: boolean;
    disabledPopoverText?: string;
};

export function TwoLineOptionCard(props: Props) {
    const {onClick, title, subtitle, icon, isSelected, isDisabled, disabledPopoverText} = props;

    const styleNames = classnames({
        [styles['two-line-option-card']]: true,
        [styles['two-line-option-card--selected']]: isSelected,
        [styles['two-line-option-card--disabled']]: isDisabled,
    });

    return (
        <button
            // For the popover to work - the button _cannot_ be passed a 'disabled={true}' prop
            // because onMouseLeave does not work as expected for disabled buttons. Wrapping the
            // button in a div and placing the listeners on that also does not work, because all
            // the content within the button is considered disabled and still does not respond
            // to onMouseLeave.
            // See: https://github.com/facebook/react/issues/18753
            onClick={isDisabled ? () => {} : onClick}
            className={styleNames}
        >
            <ListRowWithIcon
                disabledPopoverText={disabledPopoverText}
                title={title}
                icon={icon}
                subtitle={subtitle}
                isDisabled={isDisabled}
            />
        </button>
    );
}
